const getters = {
  token: state => state.user.token, // token
  secretKey: state => state.user.secretKey, // 请求头追加参数
  stage: state => state.user.stage, // 申请渠道状态
  userName: state => state.user.userName // 用户名
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js